<template>
  <div>
    <div class="tabs">
      <div class="tabs-header">
        <div class="header-item" :class="customerDocumentsClass" @click="showCustomerDocumentsTab()">
          Documents client
        </div>

        <div class="header-item" :class="customerInternalDocumentsClass" @click="showInternalDocumentsTab()">
          Documents internes
        </div>
      </div>

      <div class="tabs-content">
        <documents-list v-if="showCustomerDocuments"></documents-list>
        <internal-documents v-if="showInternalDocuments"></internal-documents>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import DocumentsList from './Documents/List'
import InternalDocuments from './InternalDocuments/Root'

export default {
  name: "Documents",
  
  components: {
    DocumentsList,
    InternalDocuments
  },

  data() {
    return {
      showCustomerDocuments: true,
      showInternalDocuments: false,
    }
  },

  computed: {
    customerDocumentsClass() {
      return this.showCustomerDocuments ? 'active' : ''
    },
    customerInternalDocumentsClass() {
      return this.showInternalDocuments ? 'active' : ''
    }
  },

  methods: {
    showCustomerDocumentsTab() {
      if (!this.showCustomerDocuments) {
        this.showInternalDocuments = false
        this.showCustomerDocuments = true
      }
    },
    showInternalDocumentsTab() {
      if (!this.showInternalDocuments) {
        this.showCustomerDocuments = false
        this.showInternalDocuments = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .tabs {
    .tabs-header {
      display: flex;
      justify-content: center;
      align-items: center;

      .header-item {
        text-transform: uppercase;
        font-weight: 600;
        background-color: #f2f2f2;
        padding: 10px 20px;
        margin-right: 5px;

        &.active {
          background-color: #e6e6e6;
        }

        &:not(.active) {
          cursor: pointer;
        }
      }
    }

    .tabs-content {
      background-color: #e6e6e6;
    }
  }
</style>


// WEBPACK FOOTER //
// client/components/Customer/Documents.vue